const schema = () => ({
  type: 'object',
  title: '',
  required: [],
  properties: {
    ip: {
      type: 'string',
      title: 'آدرس',
    },
    port: {
      type: 'number',
      title: 'پورت',
    },
    key: {
      type: 'string',
      title: 'کلید',
    },
  },
});

export default schema;
